import { proxy } from "valtio";

type StoreType = {
    isAddAppClicked: boolean;
    isAddPeripheralClicked: boolean;
    isDeletePeripheralModalOpened: boolean;
    globalDataIsUpdated: boolean | number;
    isMultiDeletePeripheralModalOpened: boolean;
    isActionsClicked: boolean;
    isEdited: boolean;
    actions: Function;
    modify: boolean;
    validationAction: any;
    keyApplication: number;
    key: any;
    isLoading: boolean;
    allSelectedRows:any
};

export const store = proxy<StoreType>({
     key: 0,
    isLoading: false,
    isAddAppClicked: false,
    isAddPeripheralClicked: false,
    isDeletePeripheralModalOpened: false,
    globalDataIsUpdated: false,
    isMultiDeletePeripheralModalOpened: false,
    isActionsClicked: false,
    isEdited: false,
    actions: () => { },
    validationAction: {},
    modify: false,
    keyApplication: 0,
    allSelectedRows:[],
});

export function setAllSelectedRows(allSelectedRows: any): void {
    store.allSelectedRows = allSelectedRows;
}
export function setIsLoading(isLoading: boolean): void {
    store.isLoading = isLoading;
}

export function setKey(key: any): void {
    store.key = key;
}

export function setModify(modify: boolean): void {
    store.modify = modify;
}
export function setIsAddAppClicked(isAddAppClicked: boolean): void {
    store.isAddAppClicked = isAddAppClicked;
}
export function setIsAddPeripheralClicked(
    isAddPeripheralClicked: boolean
): void {
    store.isAddPeripheralClicked = isAddPeripheralClicked;
}
export function setIsMultiDeletePeripheralModalOpened(
    isMultiDeletePeripheralModalOpened: boolean
): void {
    store.isMultiDeletePeripheralModalOpened = isMultiDeletePeripheralModalOpened;
}
export function setIsDeletePeripheralModalOpened(
    isDeletePeripheralModalOpened: boolean
): void {
    store.isDeletePeripheralModalOpened = isDeletePeripheralModalOpened;
}
export function setGlobalDataIsUpdated(dataIsUpdated: boolean | number): void {
    store.globalDataIsUpdated = dataIsUpdated;
}

export function setIsEdited(isEdited: boolean): any {
    store.isEdited = isEdited;
}

export function setIsActionsClicked(isActionsClicked: boolean): any {
    store.isActionsClicked = isActionsClicked;
}

export function setValidationAction(validationAction: any): any {
    store.validationAction = validationAction;
}

export function setActions(actions: any): any {
    store.actions = actions;
}
export function setKeyApplication(key: any): any {
    store.keyApplication = key;
}

export default store;
